import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const getConsents = (
    locale: string,
    localeRequiresMarketingCommunicationOptIn = false,
    privacyPolicy = ""
) => {
    if (!checkFeatureFlagGate(featureFlags.jfindSiteActivationPrivacyPolicy)) {
        // If the feature flag is not enabled, we return an empty string for the privacy policy
        privacyPolicy = "";
    }

    //TO DO: Get signup to remove this payload reqirement as this is NOT shown to the user
    return {
        site: "atlassian",
        locale: locale,
        formUrl: window.location.href,
        consents: [
            {
                key: "termsOfService",
                // showing "" as we do not show anything to the user
                displayedText: "",
                granted: true
            },
            {
                key: "privacyPolicy",
                displayedText: privacyPolicy,
                granted: true
            },
            {
                key: "generalMarketingOptIn",
                // showing "" as we do not show anything to the user
                displayedText: "",
                granted: !localeRequiresMarketingCommunicationOptIn
            }
        ]
    };
};
